import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.centers || initialState;

const makeSelectList = () =>
  createSelector(select, substate => substate.centersList);

const makeSelectSupervisorsList = () =>
  createSelector(select, substate => substate.supervisorsList);

const makeSelectAllList = () =>
  createSelector(select, substate => substate.allCentersReportList);

const makeSelectCentersStatisticsList = () =>
  createSelector(select, substate => substate.centersStatisticsList);

const makeSelectCentersStatisticsListCount = () =>
  createSelector(select, substate => substate.centersStatisticsListCount);

const makeSelectCentersStatistic = () =>
  createSelector(select, substate => substate.centersStatistic);

const makeSelectUsersListByCenterId = () =>
  createSelector(select, substate => substate.usersByCenterId);

const makeSelectUsersListBeCenter = () =>
  createSelector(select, substate => substate.usersBeAdminCenter);

const makeSelectCenter = () =>
  createSelector(select, substate => substate.center);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);
const makeSelectCountActiveList = () =>
  createSelector(select, substate => substate.countActive);
const makeSelectCountDeactiveList = () =>
  createSelector(select, substate => substate.countDeactive);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectList,
  makeSelectCenter,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectUsersListByCenterId,
  makeSelectUsersListBeCenter,
  makeSelectAllList,
  makeSelectSupervisorsList,
  makeSelectCountActiveList,
  makeSelectCountDeactiveList,
  makeSelectCentersStatisticsList,
  makeSelectCentersStatistic,
  makeSelectCentersStatisticsListCount,
};
